/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notifier = notifier;
function notifier(defaultValue) {
  var lastValue = defaultValue;
  var listeners = [];
  function fn(value) {
    lastValue = value;
    listeners.forEach(function (listener) {
      return listener(lastValue);
    });
  }
  fn.get = function () {
    return lastValue;
  };
  fn.onCalled = function (listener) {
    listeners.push(listener);
    return function () {
      listeners = listeners.filter(function (l) {
        return l !== listener;
      });
    };
  };
  fn.destroy = function () {
    listeners.length = 0;
  };
  return fn;
}


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/utils/notifier.js
// module id = 798
// module chunks = 0